import { Link } from 'react-router-dom';

const socialLinks = [
    {
    name: 'Facebook',
    href: 'https://www.facebook.com/mannaanalytics',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
      </svg>
    ),
  },

    {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/manna-analytics/',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.125 2.062 2.062 0 0 1 0 4.125zM7.114 20.452H3.558V9h3.556v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/manna_analytics/',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
      </svg>
    ),
  },

  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@MannaCloud',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },

];

export default function Footer() {
  return (
    <footer className="bg-[#05112a] border-t border-white/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-10">

          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-white rounded-sm px-2.5 py-1.5 inline-flex items-center">
                <img src="/manna-plag-logo-horizontal.png?v=2" alt="Manna Plag" style={{ height: 32, objectFit: 'contain' }} />
              </div>
            </div>
            <p className="text-[11px] text-white/40 leading-relaxed mb-4">
              Plagiarism and AI content detection for scholarly research. Built by Manna Analytics Private Limited.
            </p>

            {/* Social links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                  className="text-white/40 hover:text-white/80 transition-colors"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div>
            <p className="text-[11px] font-medium text-white/60 mb-3 uppercase tracking-wider">Product</p>
            <div className="flex flex-col gap-2">
              <Link to="/researchers"  className="text-[11px] text-white/40 hover:text-white/80 transition-colors">For researchers</Link>
              <Link to="/institutions" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">For institutions</Link>
              <Link to="/publishers"   className="text-[11px] text-white/40 hover:text-white/80 transition-colors">For publishers</Link>
              <Link to="/pricing"      className="text-[11px] text-white/40 hover:text-white/80 transition-colors">Pricing</Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <p className="text-[11px] font-medium text-white/60 mb-3 uppercase tracking-wider">Company</p>
            <div className="flex flex-col gap-2">
              <a href="https://mannaanalytics.com/about" target="_blank" rel="noopener noreferrer" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">About us</a>
              <a href="https://mannaanalytics.com/blog" target="_blank" rel="noopener noreferrer" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">Blog</a>
              <Link to="/contact" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">Contact</Link>
              <a href="https://mannaanalytics.com/careers" target="_blank" rel="noopener noreferrer" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">Careers</a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <p className="text-[11px] font-medium text-white/60 mb-3 uppercase tracking-wider">Resources</p>
            <div className="flex flex-col gap-2">
              <Link to="/faqs" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">FAQs</Link>
              <Link to="/api-reference" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">API reference</Link>
              <Link to="/lms-integration" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">LMS integration</Link>
              <Link to="/gdpr" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">GDPR compliance</Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <p className="text-[11px] font-medium text-white/60 mb-3 uppercase tracking-wider">Legal</p>
            <div className="flex flex-col gap-2">
              <Link to="/privacy" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">Privacy policy</Link>
              <Link to="/terms" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">Terms and conditions</Link>
              <Link to="/cancellation" className="text-[11px] text-white/40 hover:text-white/80 transition-colors">Cancellation and refund</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[10px] text-white/25">
            Manna Analytics Private Limited · 3/343, Town Railway Nagar, Nagercoil 629001, Tamil Nadu, India
          </p>
          <p className="text-[10px] text-white/25">
            © {new Date().getFullYear()} Manna Analytics Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}